import React from "react";
import GitHubCalendar from "react-github-calendar";

function Github() {
  const colorTheme = {
    dark: ["#181826", "#312d55", "#4c4390", "#6f61c9", "#a89cff"],
  };

  return (
    <div className="github-calendar">
      <h2>GitHub contribution rhythm</h2>
      <GitHubCalendar
        username="sagnik2001"
        blockSize={15}
        blockMargin={5}
        theme={colorTheme}
        fontSize={14}
        colorScheme="dark"
      />
    </div>
  );
}

export default Github;
